/**
 * Jeton GitLab de l'utilisateur jugé invalide par le backend (révoqué ou expiré alors que
 * le navigateur le croit valide). La prochaine connexion déconnecte d'abord la session
 * OAuth, pour qu'une vraie fenêtre de connexion s'ouvre au lieu de resservir ce jeton.
 */
let invalid = false;

export function markGitlabTokenInvalid(): void {
  invalid = true;
}

export function isGitlabTokenInvalid(): boolean {
  return invalid;
}

/** Remet l'indicateur à zéro (après déconnexion, et dans les tests). */
export function resetGitlabTokenStatus(): void {
  invalid = false;
}
